import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CampaignService } from '../../stores/campaign.service';
import dxSelectBox from 'devextreme/ui/select_box';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-campaign-selector',
  templateUrl: './campaign-selector.component.html',
  styleUrls: ['./campaign-selector.component.scss']
})

export class CampaignSelectorComponent {
  @Input()
  value?: number;

  @Output()
  valueChange = new EventEmitter<number>();

  private viewSelectionBox: dxSelectBox;
  public campaignDs: DataSource;
  public currentCampaign: number;

  constructor(
    private campaignService: CampaignService,
  ) {
    this.campaignDs = campaignService.newDataSource({
      key: 'id',
      paginate: false,
    });
  }

  onInitialized(ee) {
    this.viewSelectionBox = ee.component;
  }
  ngOnInit(): void {
    // Fetch campaigns and update viewSelectionBox
    this.campaignDs.load().then((campaigns) => {
      campaigns.forEach((val) => {
        if (val.is_current) {
          val.name = val.name + " (Actual)"

          this.currentCampaign = val.id;
        };
      });


      this.viewSelectionBox.option("value", this.value);
      this.viewSelectionBox.option("items", campaigns);
      this.viewSelectionBox.option("disabled", false);
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.value) {
      this.viewSelectionBox?.option("value", this.value);
    }
  }

  save(e: any) {
    this.valueChange.emit(e.value);
  }
}
